import { render, staticRenderFns } from "./LoadingProvider.vue?vue&type=template&id=8f0a8d74&scoped=true"
import script from "./LoadingProvider.vue?vue&type=script&lang=js"
export * from "./LoadingProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0a8d74",
  null
  
)

export default component.exports